import Layout from '@/views/main/Main.vue'
import type { RouteRecordRaw } from "vue-router";
const checkRouter: RouteRecordRaw = {
    path: '/check',
    component: Layout,
    redirect: 'noredirect',
    meta:{
        icon: 'icon-pandianguanli',
        title: '盘点管理'
    },
    children: [
        {
            path: '/check/checkRules',
            component: () => import('@/views/main/check/checkRules/checkRules.vue'),
            name: 'checkRules',
            meta: {
                title: '盘点规则设置'
            }
        },
        {
            path: '/check/checkOrder',
            component: () => import('@/views/main/check/checkOrder/checkOrder.vue'),
            name: 'checkOrder',
            meta: {
                title: '盘点计划创建'
            }
        },
        {
            path: '/check/checkAudit',
            component: () => import('@/views/main/check/checkAudit/checkAudit.vue'),
            name: 'checkAudit',
            meta: {
                title: '盘点计划审核'
            }
        },
        {
            path: '/check/checkDifference',
            component: () => import('@/views/main/check/checkDifference/checkDifference.vue'),
            name: 'checkDifference',
            meta: {
                title: '盘点差异表'
            }
        },
        {
            path: '/check/checkStatement',
            component: () => import('@/views/main/check/checkStatement/checkStatement.vue'),
            name: 'checkStatement',
            meta: {
                title: '盘点报表'
            }
        },
    ]
}

//盘点路由
export default checkRouter